import React, { Component } from 'react'

class SpecItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: {
                zh: "產品概覽",
                en: "Product Spec",
                ja: "製品概要"
            }
        }
    }
    
    render() {

        console.log(this.props.content, this.props.lang)

        return (
            <div className="spec_holder">
                <h2 className="spec_category">{this.state.title[this.props.lang]}</h2>
                <div className="spec_item_container">
                    <div className="spec_img_container">
                        <img src={this.props.img} alt="spec_img" className="spec_img" />
                    </div>
                    {this.props.title.map((item, index) => <div key={"spectitle"+index} className="spec_item">
                        <h3 className="spec_title">{item[this.props.lang]}</h3>
                        <div className="spec_content_container">{this.props.content[index][this.props.lang].map((word, index) => 
                            <p className="spec_content" key={"spec"+item.id+index}>{word}</p>)}
                        </div>
                    </div>)}
                </div>
            </div>
        );
    }
}

export default SpecItem;